import InternalServerErrorSvg from '../../assets/inlineSvg/internalServerErrorDrawing.svg'
import React, { ReactNode, useContext } from 'react'
import { Typography } from '@lightbeamai/design-system'
import { IntlContext, IntlShape } from 'react-intl'

type InternalServerErrorBannerProps = {
  className?: string
  errorHeading?: ReactNode
  errorMessage?: ReactNode
}

export function InternalServerErrorBanner(props: InternalServerErrorBannerProps) {
  const { className = '', errorHeading, errorMessage } = props

  // ? IntlContext might failed to setup
  const intl = useContext(IntlContext) as IntlShape | null

  return (
    <div className={`flex flex-col align-center xs-p-16 ${className}`}>
      <InternalServerErrorSvg />
      <Typography type="strong" variant="h3" className="xs-mt-0 xs-mb-16">
        {errorHeading ??
          intl?.formatMessage({ id: 'serverError.title' }) ??
          'Internal Server Error'}
      </Typography>
      <Typography>
        {errorMessage ??
          intl?.formatMessage({ id: 'serverError.tryAgain' }) ??
          'Please try again after some time'}
      </Typography>
    </div>
  )
}
